export default __webpack_public_path__ + "static/media/shoppinglist_card_1@3x.2eac3049.png";